import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

interface DataTableShellProps {
  icon: React.ComponentType<{ size?: number; className?: string }>;
  count: number;
  countLabel: string;
  isLoading: boolean;
  isEmpty: boolean;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export function DataTableShell({
  icon: Icon,
  count,
  countLabel,
  isLoading,
  isEmpty,
  children,
  actions,
}: DataTableShellProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="bg-card rounded-xl border border-border shadow-sm overflow-hidden min-h-[400px]">
      <div className="px-6 py-4 border-b border-border flex items-center gap-3 text-sm font-medium text-muted-foreground">
        <Icon size={18} className="text-primary" />
        <span>
          {count} {countLabel}
        </span>
        {actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
      </div>

      {isLoading ? (
        <div className="flex flex-col items-center justify-center h-64 text-muted-foreground">
          <Loader2 className="animate-spin h-8 w-8 mb-4 opacity-50" />
          <p>{t('common.loading')}</p>
        </div>
      ) : isEmpty ? (
        <div className="flex flex-col items-center justify-center h-64 text-muted-foreground/60">
          <Icon size={48} className="mb-3 opacity-30" />
          <p className="text-sm">{t('common.noResults')}</p>
        </div>
      ) : (
        <div className="overflow-x-auto">{children}</div>
      )}
    </div>
  );
}
